import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../../app/guards'
import { CreditNotesListPage } from '../../../features/sales/credit-notes-list-page'
import { creditNoteSearchSchema } from '../../../features/sales/search'

export const Route = createFileRoute('/_app/credit-notes/')({
  validateSearch: creditNoteSearchSchema,
  beforeLoad: ({ context }) => requirePermission(context.session, 'sales.read'),
  component: CreditNotesListPage,
})
